<template>
<div class="background">
  <div class="opacity">
    <mdb-card >
    <mdb-card-body>
      <form>
        <p class="h3 text-center py-2">Create An Article</p>
        <div class="grey-text">
          <mdb-input label="Enter Post Title" icon="heading" group type="text" validate error="wrong" success="right" v-model="newTitle"/>
          <vue-editor v-model="newBody" />
        </div>
        <div class="text-center py-4 mt-3">
          <mdb-btn @click ="addPost()" color="orange" type="submit">Post</mdb-btn>
        </div>
      </form>
    </mdb-card-body>
  </mdb-card>
  </div>
</div>
</template>

<script>
import { postsCollection } from '@/firebase'
import { VueEditor } from 'vue2-editor'
import mdbInput from 'mdbvue/lib/components/mdbInput'
import mdbBtn from 'mdbvue/lib/components/mdbBtn'
import mdbCard from 'mdbvue/lib/components/mdbCard'
import mdbCardBody from 'mdbvue/lib/components/mdbCardBody'

export default {
  name: 'Basic',
  components: {
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    VueEditor
  },
  data () {
    return {
      newTitle: '',
      newBody: '',
      posts: []
    }
  },
  firestore () {
    return {
      posts: postsCollection.orderBy('createdAt', 'desc')
    }
  },
  methods: {
    addPost () {
      postsCollection.add({
        title: this.newTitle,
        body: this.newBody,
        id: this.posts.length,
        createdAt: new Date()
      })
      this.newTitle = ''
      this.newBody = ''
    }
  }
}
</script>

<style scoped>
.background{
background-image: url("~@/assets/blog.svg");
background-repeat: no-repeat;
background-size: contain;
background-attachment: fixed;
background-position: center;
-webkit-background-size: contain;
-moz-background-size: contain;
-o-background-size: contain;
padding-bottom: 100px;
height: 100%;
}
.opacity{
  opacity: 0.9;
}
</style>
